import { SVGProps } from 'react';

const Axis3D = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M13.5 10.5 15 9M4 4v15a1 1 0 0 0 .293.707m0 0A1 1 0 0 0 5 20h15m-15.707-.293L6 18m3-3 1.5-1.5"
    />
  </svg>
);
export default Axis3D;
